module.exports = __webpack_public_path__ + "img/COMBO RADIO PURPLE.a0f2d16.svg";